/* =============================================
   TACTICAL MEGAMENU
   Native desktop panels + branch actions
   ============================================= */
(function () {
  'use strict';

  var DESKTOP_QUERY = window.matchMedia('(min-width: 1024px)');
  var REDUCE_ANIMATIONS = document.body && 'reduceAnimations' in document.body.dataset;
  var HOVER_INTENT_DELAY = 280;
  var SCROLL_SUPPRESS_MS = 700;
  var lastScrollAt = 0;

  function markRecentScroll() {
    lastScrollAt = Date.now();
  }

  window.addEventListener('scroll', markRecentScroll, { passive: true });
  window.addEventListener('wheel', markRecentScroll, { passive: true });
  window.addEventListener('touchmove', markRecentScroll, { passive: true });

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getTrigger(item) {
    return item.querySelector('[data-tac-trigger]');
  }

  function getPanel(item) {
    return item.querySelector('[data-tac-panel]');
  }

  function bindRail(root) {
    $$('[data-tac-switch]', root).forEach(function (button) {
      if (button.dataset.tacBound === 'true') return;
      button.dataset.tacBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        var handle = button.getAttribute('data-tac-switch');
        var collection = button.getAttribute('data-tac-collection');

        if (handle === 'usaaf') {
          window.location.href = '/pages/usaaf-order-of-battle';
          return;
        }

        if (collection) {
          window.location.href = '/collections/' + collection;
        }
      });
    });
  }

  function bindKeyboard(panel) {
    if (!panel || panel.dataset.tacKeyboard === 'true') return;
    panel.dataset.tacKeyboard = 'true';

    panel.addEventListener('keydown', function (event) {
      if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) return;

      var focusables = $$('a[href], button:not([disabled])', panel).filter(function (el) {
        return el.offsetParent !== null && el.closest('[aria-hidden="true"]') === null;
      });

      var currentIndex = focusables.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      event.preventDefault();

      var nextIndex = currentIndex;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        nextIndex = Math.min(focusables.length - 1, currentIndex + 1);
      }

      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        nextIndex = Math.max(0, currentIndex - 1);
      }

      focusables[nextIndex].focus();
    });
  }

  function initNativeDesktop() {
    var items = $$('[data-tac-desktop-item]');
    if (!items.length) return;

    var activeItem = null;
    var openTimer = null;
    var closeTimer = null;

    function clearOpenTimer() {
      if (openTimer) {
        window.clearTimeout(openTimer);
        openTimer = null;
      }
    }

    function clearCloseTimer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function setItemState(item, isOpen) {
      if (!item) return;

      var trigger = getTrigger(item);
      var panel = getPanel(item);
      if (!trigger || !panel) return;

      item.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }

    function closeItem(item) {
      if (!item) return;
      setItemState(item, false);

      if (activeItem === item) {
        activeItem = null;
      }
    }

    function openItem(item) {
      if (!DESKTOP_QUERY.matches || !item) return;

      if (activeItem && activeItem !== item) {
        closeItem(activeItem);
      }

      activeItem = item;
      setItemState(item, true);
    }

    function scheduleOpen(item) {
      if (!DESKTOP_QUERY.matches) return;

      clearCloseTimer();
      clearOpenTimer();

      var delay = REDUCE_ANIMATIONS ? 0 : HOVER_INTENT_DELAY;

      openTimer = window.setTimeout(function () {
        openTimer = null;
        if (Date.now() - lastScrollAt < SCROLL_SUPPRESS_MS) return;
        openItem(item);
      }, delay);
    }

    function scheduleClose(item) {
      clearOpenTimer();
      clearCloseTimer();

      closeTimer = window.setTimeout(function () {
        if (activeItem === item) {
          closeItem(item);
        }
      }, REDUCE_ANIMATIONS ? 0 : 90);
    }

    items.forEach(function (item) {
      var trigger = getTrigger(item);
      var panel = getPanel(item);

      setItemState(item, false);
      bindRail(item);
      bindKeyboard(panel);

      item.addEventListener('mouseenter', function () {
        scheduleOpen(item);
      });

      item.addEventListener('mousemove', function () {
        if (activeItem === item || openTimer) return;
        scheduleOpen(item);
      });

      item.addEventListener('mouseleave', function (event) {
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        scheduleClose(item);
      });

      item.addEventListener('focusin', function () {
        openItem(item);
      });

      item.addEventListener('focusout', function (event) {
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        scheduleClose(item);
      });

      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();

          if (activeItem === item) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (!activeItem || activeItem.contains(event.target)) return;
      closeItem(activeItem);
    });

    document.addEventListener('focusin', function (event) {
      if (!activeItem || activeItem.contains(event.target)) return;
      closeItem(activeItem);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !activeItem) return;

      var trigger = getTrigger(activeItem);
      closeItem(activeItem);

      if (trigger) {
        trigger.focus();
      }
    });

    function handleBreakpointChange(event) {
      if (event.matches) return;

      clearOpenTimer();
      clearCloseTimer();
      closeItem(activeItem);
    }

    if (DESKTOP_QUERY.addEventListener) {
      DESKTOP_QUERY.addEventListener('change', handleBreakpointChange);
    } else if (DESKTOP_QUERY.addListener) {
      DESKTOP_QUERY.addListener(handleBreakpointChange);
    }

  }

  function init() {
    bindRail(document);
    initNativeDesktop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
